//
// Generated class AccountingJournalGroupTemplate
//

/// <reference path="AccountingJournalGroupTemplate_ManagedObject.ts" />

class AccountingJournalGroupTemplate extends AccountingJournalGroupTemplate_ManagedObject
{

}
